module.exports = __webpack_public_path__ + "media/images/themes/default/logo-light-8a41f9b25b29c5c7dd6e7f86bc075b53.svg";